import { gql } from '@apollo/client'

export const GET_DISPLAY_BY_QR_ID = gql`
  query GetDisplayByQrId($qrId: ID!) {
    displayByQrId(qrId: $qrId) {
      id
      name
      qrId
      images {
        url
      }
      store {
        name
      }
    }
  }
`
